import URL from '@/creditflowresearch/Router/urlConstants';
import Product, { AbsProduct, IgcProduct, HycProduct } from '@/creditflowresearch/domain/Product';
import Market, { EmergingMarket } from '@/creditflowresearch/domain/Market';

class MarketOverviewUrlResolver {
  resolve(entity: Product | Market): string {
    if (entity instanceof IgcProduct) return URL.MARKET_OVERVIEW_IGC;
    if (entity instanceof HycProduct) return URL.MARKET_OVERVIEW_HYC;
    if (entity instanceof AbsProduct) return URL.MARKET_OVERVIEW_ALL;
    if (entity instanceof EmergingMarket) return URL.MARKET_OVERVIEW_EM;

    throw new Error(`Unknown entity type: ${ entity.constructor.name }`);
  }
}

export default MarketOverviewUrlResolver;
